import React, { useEffect, useRef } from "react";
import soundFile from '../audio/rg055a.wav'

function Game() {
  const dSpike = useRef(null);
  const george = useRef(null);
  const audio = new Audio(soundFile)

  const startGame = () => {
    george.current.classList.add("obstacle");
    let count = 0;
    let isAlive = setInterval(() => {
      count++;
      let dSpikeTop = parseInt(
        window.getComputedStyle(dSpike.current).getPropertyValue("top")
      );
      let georgeLeft = parseInt(
        window.getComputedStyle(george.current).getPropertyValue("left")
      );

      if (georgeLeft < 40 && georgeLeft > 10 && dSpikeTop >= 140) {
        window.clearInterval(isAlive);
        audio.play()
        george.current.classList.remove("obstacle");
        alert("Game Over Score: " + count);
      }
    }, 10);
  };

  useEffect(() => {
    document.addEventListener("keydown", detectKeyDown, true);
  }, []);

  const detectKeyDown = (e) => {
    if (e.key === "w" && dSpike.classList != "jump") {
      dSpike.current.classList.add("jump");
      setTimeout(() => {
        dSpike.current.classList.remove("jump");
      }, 300);
    }
  };

  return (
    <>
      <p style={{ color: "black" }}>
        Press the Start button to start the game. Jump by pressing the W key
      </p>
      <button onClick={() => startGame()}>Start</button>
      <div className="game">
        <div id="deathSpike" ref={dSpike}></div>
        <div id="george" ref={george}></div>
      </div>
    </>
  );
}

export default Game;
